import './index.scss'

import ReactDOM from 'react-dom'
import React from 'react'
import { version } from '../package.json'
import { themeChanger as setTheme } from 'mondrian-vanilla/core/util/theme-changer'
import Alert from './components/Alert'
import BrandGroup from './components/BrandGroup'
import Button from './components/Button'
import CopyContainer from './components/CopyContainer'
import Divider from './components/Divider'
import Heading from './components/Heading'
import Text from './components/Text'
import Header from './components/Header'
import Footer, { FooterList } from './components/Footer'
import Link from './components/Link'
import IconGroup from './components/IconGroup'
import { Input } from './components/Input'
import { Container, Row, Col } from './components/Grid/'
import Accordion from './components/Accordion'
import Avatar from './components/Avatar'
import Checkbox from './components/Checkbox'
import Tag from './components/Tag'
import Toggle from './components/Toggle'
import Spinner from './components/Spinner'
import Radio from './components/Radio'
import Shortcut from './components/Shortcut'
import Collapse from './components/Collapse'
import ProgressBar from './components/ProgressBar'
import RatingStars from './components/RatingStars'
import LinkList from './components/LinkList'
import Slider from './components/Slider'
import Steps from './components/Steps'
import Image from './components/Image'
import Banner from './components/Banner'
import Topic from './components/Topic'
import TopicDetails from './components/TopicDetails'
import TabSelect from './components/TabSelect'
import Breadcrumb from './components/Breadcrumb'
import Swiper from './components/Swiper'
import Card from './components/Card'
import Calendar from './components/Calendar'
import Countdown from './components/Countdown'
import Subtitle from './components/Subtitle'
import HelpPassword from './components/HelpPassword'
import Price from './components/Price'
import LinkDetails from './components/LinkDetails'
import Modal from './components/Modal'

import Multimedia from './components/Multimedia'
import Tooltip from './components/Tooltip'
import Select from './components/Select'

try {
  window.MondrianReact = {
    setTheme: setTheme,
    version: version
  }
} catch (err) {
  console.log(
    'Warning! Window object not founded. SeTheme will not be set globally.\nHint:If you want to use setTheme, use withs imports.'
  )
}

export {
  // Core
  ReactDOM,
  React,
  setTheme,
  version,
  // Components
  Alert,
  Button,
  BrandGroup,
  Modal,
  Divider,
  Heading,
  Text,
  Header,
  Footer,
  FooterList,
  Link,
  Input,
  IconGroup,
  Container,
  CopyContainer,
  Row,
  Col,
  Countdown,
  Calendar,
  Accordion,
  Avatar,
  Checkbox,
  Tag,
  Toggle,
  Spinner,
  Radio,
  Shortcut,
  Collapse,
  ProgressBar,
  RatingStars,
  LinkList,
  Slider,
  Steps,
  Image,
  Banner,
  Topic,
  TopicDetails,
  TabSelect,
  Breadcrumb,
  Multimedia,
  Swiper,
  Card,
  Subtitle,
  HelpPassword,
  Price,
  LinkDetails,
  Tooltip,
  Select
}
